export default __webpack_public_path__ + "static/spider-pattern-760c964818eddd8e55cd76fa1ea95ef1.webp";